const state = {
	id : '',
	active : false,
	title : '',
	initSearch (){},
	fab: '',
	originMethod:''
}

const mutations = {
	changeDeduceId (state,payload){
		state.id = payload;
	},
	changeOriginMethod (state,payload){
		state.originMethod = payload;
	},
	/**
	 * 推演 弹窗
	 * @param {*} state
	 * @param {*} payload
	 */
	changeDeduceStatus (state,payload){
		state.active = payload;
	},
	changeDeduceTitle (state,payload){
		state.title = payload;
	},
	changeDeduceSearch (state,payload){
		state.initSearch = payload;
	},
	changeDeducFab (state,payload){
		state.fab = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/deduceDialog.js